import { BoardUid } from "./base";

export type SessionData = BoardUid & {
  createdDate: Date;
  isTimed?: boolean;
  targetTime?: number;
  startTime?: Date;
  endTime?: Date;
  presentedUid?: string;
  presentedTime?: Date;
  order?: string[]; // category uids
}

export type SerializedSessionData = BoardUid & {
  createdDate: number;
  isTimed?: boolean;
  targetTime?: number;
  startTime?: number;
  endTime?: number;
  presentedUid?: string;
  presentedTime?: number;
  order?: string[];
}

export function serializeSession(s: SessionData): SerializedSessionData {
  return {
    ...s,
    createdDate: s.createdDate.getTime(),
    startTime: s.startTime?.getTime(),
    endTime: s.endTime?.getTime(),
    presentedTime: s.presentedTime?.getTime(),
  };
}

export enum SessionStatus {
  notStarted = 'notStarted',
  inProgress = 'inProgress',
  completed = 'completed',
}

export function sessionStatus(session: SessionData) {
  if (!session.startTime) return SessionStatus.notStarted;
  if (session.startTime && !session.endTime) return SessionStatus.inProgress;
  return SessionStatus.completed;
}

export const sessionTransform = (val: any): SessionData => {
  // react-firebase-hooks calls transforms with `null` when the snapshot has no data.
  if (val == null) return val as unknown as SessionData;
  return <SessionData>({
    ...val,
    createdDate: new Date(val.createdDate),

    targetTime: val.targetTime ?? undefined,
    startTime: val.startTime ? new Date(val.startTime) : undefined,
    endTime: val.endTime ? new Date(val.endTime) : undefined,
    presentedTime: val.presentedTime ? new Date(val.presentedTime) : undefined,
  });
};
